import { useEffect, useState } from "react";

export type ScreenSize = {
  width: number;
  height: number;
};

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<ScreenSize>({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const listener = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  });
  return windowSize;
};
